import { render, staticRenderFns } from "./Nocode.vue?vue&type=template&id=127e6be0"
import script from "./Nocode.vue?vue&type=script&lang=js"
export * from "./Nocode.vue?vue&type=script&lang=js"
import style0 from "./Nocode.vue?vue&type=style&index=0&id=127e6be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports